/**
 * Приблизительный размер области под грид
 *
 * Используется для корректного рендеринга грида и строк при серверном рендеринге
 *
 * Рекомендуется давать ОЦЕНКУ СВЕРХУ (максимальное возможное значение),
 * чтобы в случае чего отрендерить больше строк чем действительно нужно
 */
export const GRID_VIRTUALIZATION_INITIAL_RECT = { width: 1920, height: 1080 } as const;

export const FILTERS_OPEN = 'filtersOpen';
